import { Action, createReducer, on } from '@ngrx/store'

import * as GeolocationActions from './geolocation.actions'
import { Geolocation } from './geolocation.models'

export const GEOLOCATION_FEATURE_KEY = 'geolocation'

export interface GeolocationState extends Partial<Geolocation> {
  loaded: boolean
}

export interface GeolocationPartialState {
  readonly [GEOLOCATION_FEATURE_KEY]: GeolocationState
}

export const initialGeolocationState = {
  loaded: false,
}

const reducer = createReducer(
  initialGeolocationState,
  on(GeolocationActions.loadGeoLocation, (state) => ({ ...state, loaded: false })),
  on(GeolocationActions.loadGeolocationSuccess, (state, { geolocation }) => ({
    ...state,
    ...geolocation,
    loaded: true,
  })),
  on(GeolocationActions.loadGeolocationFailure, (state) => ({ ...state, loaded: true })),
)

export function geolocationReducer(state: GeolocationState | undefined, action: Action) {
  return reducer(state, action)
}
